<template>
    <div>
        <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">
            <a-form-item label="关键字">
                <a-input
                    v-model="searchP.keyword"
                    placeholder="请输入关键字"
                ></a-input>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="handleSubmit">查询</a-button>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>

export default {
    components:{
    },
    data(){
        return {
            form: this.$form.createForm(this),
            searchP:{
                keyword:''
            },
        }
    },
    methods:{
        handleSubmit(){
            this.$emit("handleSearch",this.searchP);
        }
      
    },
    mounted(){
        this.handleSubmit();
    }
}

</script>

<style>
    .myform{
        margin-bottom: 20px;
    }
</style>

